import { IconWrapper } from './IconWrapper'
import type { IIconProps } from './props'

export function BurgerIcon({ size = '14px', className }: IIconProps) {
  return (
    <IconWrapper size={size} className={className}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_18019_24307)">
          <path
            d="M3.93359 10.0303H20.4336"
            stroke="black"
            strokeWidth="1.57782"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.93359 14.5303H20.4336"
            stroke="black"
            strokeWidth="1.57782"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_18019_24307">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  )
}
